(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    if (!window.scoffPersonalisationValidation) {
  window.scoffPersonalisationValidation = true;
  const validate = form => {
    const input = form && form.querySelector('[data-scoff-name]');
    if (!input) return true;
    input.value = input.value.trim();
    input.setCustomValidity(input.value ? '' : input.dataset.requiredMessage);
    if (!input.checkValidity()) {
      input.reportValidity();
      input.focus();
      return false;
    }
    return true;
  };
  document.addEventListener('input', event => {
    if (event.target.matches('[data-scoff-name]')) {
      event.target.setCustomValidity('');
    }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('button[data-add-to-cart]');
    if (button && !validate(button.closest('form'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!validate(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scoff-signup-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
let pending;
document.addEventListener('submit', event => {
const launcher=event.target.closest('[data-scoff-signup-launcher]');
if(!launcher)return;
event.preventDefault();
event.stopImmediatePropagation();
if(!launcher.reportValidity())return;
if(pending)pending.disconnect();
const email=launcher.querySelector('input[type="email"]').value.trim();
const error=launcher.querySelector('[data-scoff-signup-error]');
error.hidden=true;
let filled=false;
const fillEmail=()=>{
const field=document.querySelector('form[data-testid="klaviyo-form-U8Hiws"] input[type="email"]');
if(!field)return;
if(field.value===email){filled=true;return;}
Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(field,email);
field.dispatchEvent(new Event('input',{bubbles:true}));
field.dispatchEvent(new Event('change',{bubbles:true}));
filled=true;
};
const observer=new MutationObserver(fillEmail);
pending=observer;
observer.observe(document.body,{childList:true,subtree:true});
window._klOnsite=window._klOnsite||[];
window._klOnsite.push(['openForm','U8Hiws',fillEmail]);
fillEmail();
let attempts=0;
const retry=setInterval(()=>{fillEmail();if(++attempts>=100){clearInterval(retry);observer.disconnect();if(!filled)error.hidden=false;}},100);
},true);
})();
  } catch(e) { console.error(e); }
})();

})();
